import Reveal from './ui/Reveal';
import RichText from './ui/RichText';
import HtmlEmbed from './ui/HtmlEmbed';
import { pricing, waitlistForm } from '../data/content';

function CheckBullet() {
  return (
    <span className="chk" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 6 9 17l-5-5" />
      </svg>
    </span>
  );
}

export default function Pricing() {
  return (
    <section className="alt" id="pricing">
      <div className="wrap">
        <Reveal className="center narrow">
          <span className="eyebrow">Enrolment</span>
          <h2 className="h-sec">Join the next LNG Ready cohort.</h2>
          <p className="lede mt-m">
            A structured six-week live coaching experience, kept deliberately small so every
            participant is coached.
          </p>
        </Reveal>

        <Reveal className="price-wrap mt-l" delay={1}>
          <div className="price-card">
            <div className="price-top">
              <div className="eyebrow" style={{ marginBottom: 6 }}>
                LNG Ready · Live Cohort
              </div>
              <div className="amount closed">{pricing.amount}</div>
              <p className="waitlist-lead">{pricing.waitlistLead}</p>
              {/* beehiiv's loader renders its own inline form in here */}
              <HtmlEmbed className="beehiiv-embed" html={waitlistForm} />
              <p className="cta-note">{pricing.waitlistAction}</p>
            </div>

            <div className="price-list">
              <ul>
                {pricing.features.map((feature) => (
                  <li key={feature}>
                    <CheckBullet />
                    <span>
                      <RichText text={feature} />
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
